export const selectVoucherList = ({ voucher }) => voucher.vouchers;
export const selectVoucherForm = ({ voucher }) => voucher.form;
export const selectVoucherAvailability = ({ voucher }) =>
  voucher.voucherAvailability;
